import { isNil } from 'lodash/fp';
import { type ImageWebPageBlockDataFragment } from '../../../../../api/fragments/ImageWebPageBlockData';
import usePublic from '../../../../../utilities/usePublic';
import useTranslatedString from '../../../../../utilities/useTranslatedString';
import {
    StyledImage,
    StyledImageBlockContainer,
    StyledImageBlockImageContainer,
    StyledImageBlockImageDetailsContainer,
    colImageSpan,
    colDetailSpan,
    BlockButton,
    ImageTitleBlock,
} from '../shared';
import ImageList from './ImageList';

type ImageBlockProps = {
    imageBlock: ImageWebPageBlockDataFragment;
};

const ImageBlock = ({ imageBlock }: ImageBlockProps) => {
    const translated = useTranslatedString();
    const fallbackSrc = usePublic('empty.svg');

    const image = !isNil(imageBlock.image) ? imageBlock.image.url : fallbackSrc;
    const titleBlock = translated(imageBlock.title);

    return (
        <StyledImageBlockContainer>
            <StyledImageBlockImageContainer {...colImageSpan}>
                <StyledImage preview={false} src={image} />
            </StyledImageBlockImageContainer>
            <StyledImageBlockImageDetailsContainer {...colDetailSpan}>
                <div>
                    {titleBlock && (
                        <ImageTitleBlock itemProp="alternativeHeadline" level={3}>
                            {titleBlock}
                        </ImageTitleBlock>
                    )}
                    <ImageList descriptions={imageBlock.descriptions} />
                    <BlockButton button={imageBlock.button} />
                </div>
            </StyledImageBlockImageDetailsContainer>
        </StyledImageBlockContainer>
    );
};

export default ImageBlock;
